import React from 'react';

type ChevronIconProps = {
  className: string;
};

const ChevronIcon: React.SFC<ChevronIconProps> = ({ ...props }): JSX.Element => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1 1L6 6L11 1" stroke="#5B7179" />
    </svg>
  );
};

export default ChevronIcon;
